import {
  Delete,
  Get,
  Post,
  PostFormData,
  Put,
  getAPIUrl,
} from "../../../services/apiMethod";
import { PlotEndpoint } from "./PlotEndPoints";

export const getPlotDetails = (param = "") => {
  const url = getAPIUrl(PlotEndpoint.getPlotDetails, param);
  return Get(url);
};
export const getPlotDetailsbyId = (param = "") => {
  const url = getAPIUrl(PlotEndpoint.getPlotDetailsbyId, param);
  return Get(url);
};
export const modifyStatus = (param = "") => {
  const url = getAPIUrl(PlotEndpoint.modifyStatus, param);
  return Get(url);
};
export const addPlot = (data, param = "") => {
  const url = getAPIUrl(PlotEndpoint.addPlot, param);
  return PostFormData(url, data, true);
};
export const editPlot = (data, param = "") => {
  const url = getAPIUrl(PlotEndpoint.editPlot, param);
  return Post(url, data, true);
};
export const deletePlot = (param = "") => {
  const url = getAPIUrl(PlotEndpoint.deletePlot, param);
  return Delete(url, param);
};
export const deleteImageAPI = (param = "") => {
  const url = getAPIUrl(PlotEndpoint.deleteImageAPI, param);
  return Delete(url, param);
};
export const uploadImageAPI = (data, param = "") => {
  const url = getAPIUrl(PlotEndpoint.uploadImageAPI, param);
  return PostFormData(url, data, true);
};
